import { Collection } from 'src/app/models/collection';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { GetCollections, GetMandatoryTrainingCollection, ResetStore } from './collections.actions';
import { patch } from '@ngxs/store/operators';
import { CollectionsService } from './collections.service';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LoadingModel } from 'src/app/_core/state/loading.model';

export type CollectionsStateModel = LoadingModel & {
  collections: Collection[];
  mandatoryTrainingCollection: Collection | undefined;
};

export const initialState: CollectionsStateModel = {
  collections: [],
  mandatoryTrainingCollection: undefined,
  isLoading: false,
};

@State<CollectionsStateModel>({
  name: 'collections',
  defaults: initialState,
})
@Injectable()
export class CollectionsState {
  private readonly collectionsService = inject(CollectionsService);

  @Selector()
  static isLoading(state: CollectionsStateModel) {
    return state.isLoading;
  }

  @Selector()
  static collections(state: CollectionsStateModel) {
    return state.collections;
  }

  @Selector()
  static mandatoryTrainingCollection(state: CollectionsStateModel) {
    return state.mandatoryTrainingCollection;
  }

  @Action(GetCollections)
  getCollections(context: StateContext<CollectionsStateModel>, { locale }: GetCollections): Observable<Collection[]> {
    return this.collectionsService.getCollections(locale).pipe(
      tap((collections) => {
        context.setState(patch<CollectionsStateModel>({ collections }));
      }),
      map(() => context.getState().collections)
    );
  }

  @Action(GetMandatoryTrainingCollection)
  getMandatoryTrainingCollection(context: StateContext<CollectionsStateModel>): Observable<Collection | undefined> {
    context.setState(patch<CollectionsStateModel>({ isLoading: true }));
    return this.collectionsService.getMandatoryTrainingCollection().pipe(
      tap((mandatoryTrainingCollection) => {
        context.setState(patch<CollectionsStateModel>({ mandatoryTrainingCollection, isLoading: false }));
      }),
      map(() => context.getState().mandatoryTrainingCollection)
    );
  }

  @Action(ResetStore)
  resetStore(context: StateContext<CollectionsStateModel>) {
    context.setState(initialState);
  }
}
